import React from 'react';
import { useTranslation } from 'react-i18next';

export const WeatherCondition: React.FC = () => {
  const { t } = useTranslation('common');

  return <p>{t('dialogWorkInProgress.header')}</p>;
};
